import { ChangeDetectionStrategy, Component, computed, inject, input, OnInit, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

import { BaasAppState, BaasConfigurationService } from '@lvflanders/bar';
import { BaasClickOutsideBehavior, BarI18nPipe } from '@lvflanders/bar-ng-ui';

import { StartschermV2StateService } from '../../services/v2/startscherm-v2-state.service';
import { StartschermMailOnsDialog } from '../startscherm-mail-ons-dialog/startscherm-mail-ons-dialog';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { StartschermV2FormatteerInternalService } from '../../services/v2/startscherm-v2-formatteer-internal.service';

@Component({
    selector: 'startscherm-help-widget',
    templateUrl: './startscherm-help-widget.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BaasClickOutsideBehavior, BarI18nPipe, MatIcon, MatIconButton]
})
export class StartschermHelpWidget implements OnInit {
    readonly state = inject(StartschermV2StateService);
    readonly #appState = inject(BaasAppState);
    readonly #sanitizer = inject(DomSanitizer);
    readonly #dialog = inject(MatDialog);
    readonly #configurationService = inject(BaasConfigurationService);
    readonly #startschermV2FormatteerInternalService = inject(StartschermV2FormatteerInternalService);

    readonly helpLink = input<string | undefined>(undefined);

    protected readonly isVisible = signal(false);
    protected readonly contactUrl = signal<SafeUrl | undefined>(undefined);
    protected readonly clientNumber = signal<string | undefined>(undefined);

    protected readonly helpUrl = computed(() => {
        const helpLink = this.helpLink() ? this.helpLink() : this.state.helpLink();
        if (helpLink) return this.#sanitizer.bypassSecurityTrustUrl(helpLink);
        return undefined;
    });
    protected readonly parsedClientNumber = computed(() => {
        const clientNumber = this.clientNumber();
        return this.#startschermV2FormatteerInternalService.formatteerKlantnummer(clientNumber);
    });

    async ngOnInit(): Promise<void> {
        this.isVisible.set(this.state.isIntern || this.state.isExtern);
        this.clientNumber.set(this.#appState.basiscontext.klantnummer);
        const contactUrl = await this.#configurationService.readValue({ appCode: 'STA2WEB', pathAndKey: 'Startscherm2\\Web\\BelOnsUrl' });
        this.contactUrl.set(this.#sanitizer.bypassSecurityTrustUrl(contactUrl));
    }

    protected openMailons(): void {
        this.#dialog.open(StartschermMailOnsDialog, {
            width: '650px',
            height: '95vh'
        });
    }
}
